import { Auth, firestore } from "../../firebase";
import { User } from "../../models/user";

export const uiConfig = {
  signInOptions: [
    Auth.GoogleAuthProvider.PROVIDER_ID,
    Auth.FacebookAuthProvider.PROVIDER_ID,
    // Auth.TwitterAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    signInSuccessWithAuthResult: function (authResult: any, redirectUrl: any) {
      console.log(authResult);
      let user: User = {
        accountType: "fan",
        bio: "",
        email: authResult.user.email,
        fans: [],
        firstName: "",
        id: authResult.user.uid,
        lastName: "",
        location: {
          city: "",
          country: "",
        },
        pimage: authResult.user.photoUrl,
        username: authResult.user.email.split(`@`)[0],
        website: "",
      };

      firestore.collection("users").doc(authResult.user.uid).set(user).then(
        () => true,
      ).catch(() => false);

      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      return true;
    },
  },
  signInFlow: "popup",
  // Other config options...
};
